module.exports = __webpack_public_path__ + "img/img-spadegaming-fish.87e9d53e.png";